import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { NotificationsSliceInitialState } from "../../types/reduxSlices";

const initialState: NotificationsSliceInitialState = {
  notificationsTotalCount: 0,
  hasNewNotifications: false,
};

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    handleUpdateNotificationsTotalCount: (
      state,
      action: PayloadAction<number>,
    ) => {
      state.notificationsTotalCount = action.payload;
    },
    handleUpdateNewNotificationsStatus: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.hasNewNotifications = action.payload;
    },
  },
});

export const {
  handleUpdateNotificationsTotalCount,
  handleUpdateNewNotificationsStatus,
} = notificationsSlice.actions;

export default notificationsSlice.reducer;
